import React, { useState } from "react";
import TableComponent from "component/molecules/Table/TableComponent";
import { useNavigate } from "react-router-dom";
import { workflow } from "hooks/endpoints";
import { workflowToast } from "helpers/toastMessages";
import PriorityModal from "./new-workflow/NewPrioritModal";
import styles from "./SettingsWorkflowTEmp.module.scss";
import { useBrandingContext } from "app-context/BrandingsContext";
import Tooltip from "component/Custom/tooltip/Tooltip";
import { headerData } from "../categories/factory/categoriesHeader";
export const tableHeader = {
  hasEdit: true,
  hasDelete: true,
  hasSearch: true,
  hasPaging: true,
  // hasExport: true,
  isSystem: true,
  deleteSubtext: workflowToast.deleteConfirmation,
  fields: [
    {
      fieldName: "name",
      headerName: "Name",
    },
    {
      fieldName: "description",
      headerName: "Description",
    },
    {
      fieldName: "status",
      headerName: "Status",
      isSwitch: true,
    },
    {
      fieldName: "dateUpdated",
      headerName: "Updated",
      isDatetime: true,
      isDesc: true,
      hasSort: true,
    },
  ],
};

const SettingsWorkflowTemp = ({
  api,
  refetch,
  id,
  setItem,
  setIsOpen,
  isSystem,
  isCustom,
  setRefetch,
}) => {
  const { brandingData } = useBrandingContext();
  const [isPriorityOpen, setIsPriorityOpen] = useState(false);
  const [priorityItem, setPriorityItem] = useState(null);
  const navigate = useNavigate();

  const handleEdit = (item) => {
    setItem(item);
    setIsOpen(true);
  };

  const handleRowClick = (item) => {
    navigate(`/workflow/${item.id}`, { state: item.botId });
    window.location.reload();
  };
  const rowButtons = [
    {
      type: "icon",
      name: "priority",
      func: (item) => {
        setPriorityItem(item);
        setIsPriorityOpen(true);
      },
      iconTooltip: "Remove Priority",
      reversedTooltip: "Add Priority",
      isCustom: true,
    },
  ];

  const renderPriority = ({ headerData, item }) => {
    return (
      <Tooltip content="Priority">
        <div
          onClick={(e) => {
            e.stopPropagation();
            setPriorityItem(item);
            setIsPriorityOpen(true);
          }}
        >
          {!item.isSystem ? (
            item?.priority ? (
              <div
                className={styles.priority}
                style={{ backgroundColor: brandingData?.page_ButtonColor }}
              >
                <span className={styles.number}>{item.priority}</span>
              </div>
            ) : (
              <div className={`${styles.priority} ${styles.unknown}`}>
                <span className={styles.number}>!</span>
              </div>
            )
          ) : (
            ""
          )}
        </div>
      </Tooltip>
    );
  };

  return (
    <>
      <TableComponent
        rowKey="id"
        headerData={tableHeader}
        actions={{
          hasEdit: {
            func: handleEdit,
          },
          onRowClick: {
            hasRowClick: true,
            func: handleRowClick,
          },
        }}
        // renderAdditionalComponent={renderPriority}
        api={{
          get: {
            url: api,
            params: { botId: id, IsSystem: isSystem },
          },
          delete: {
            url: workflow.delete,
          },
          toggleUrl: workflow?.disableWorkflow,
          toggleToast: {
            error: workflowToast.activateIncomplete,
            deactivate: workflowToast.deactivateConfirm,
          },
          toggleConfirm: true,
        }}
        rowButtons={isCustom ? rowButtons : {}}
        isRefetch={refetch}
        noPadding
      />
      <PriorityModal
        isOpen={isPriorityOpen}
        item={priorityItem}
        onClose={() => {
          setIsPriorityOpen(false);
          setPriorityItem(null);
        }}
        setRefetch={setRefetch}
      />
    </>
  );
};

export default SettingsWorkflowTemp;
